/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../utils/constants';

const IDS = {
  HOME_CARD_LOAN: 'payments.home.card.loan',
  SPLASHPAGE_AUTOPAY_BUTTON_LABEL: 'payments.splash.autopay.button.label',
  SPLASHPAGE_AUTOPAY_TEXT_ABILITYTOREMIT: 'payments.splash.autopay.text.abilityToRemit',
  SPLASHPAGE_AUTOPAY_TEXT_ELIMINATESRISKS: 'payments.splash.autopay.text.eliminatesRisks',
  SPLASHPAGE_AUTOPAY_TEXT_ENVIRONMENTALLYFRIENDLY: 'payments.splash.autopay.text.environmentallyFriendly',
  SPLASHPAGE_AUTOPAY_TEXT_MORTGAGEPAYMENTS: 'payments.splash.autopay.text.mortgagePayments',
  SPLASHPAGE_AUTOPAY_TITLE: 'payments.splash.autopay.title',
};

const enMessages = {
  // Payments Home
  [IDS.HOME_CARD_LOAN]: 'Loan',
  // Payments Splash
  [IDS.SPLASHPAGE_AUTOPAY_BUTTON_LABEL]: 'Set Up Autopay',
  [IDS.SPLASHPAGE_AUTOPAY_TEXT_ABILITYTOREMIT]: 'Ability to remit additional principal funds with every automatic payment.',
  [IDS.SPLASHPAGE_AUTOPAY_TEXT_ELIMINATESRISKS]: 'Eliminates risks associated with lost or delayed mail.',
  [IDS.SPLASHPAGE_AUTOPAY_TEXT_MORTGAGEPAYMENTS]: 'Mortgage payments will be made on time.',
  [IDS.SPLASHPAGE_AUTOPAY_TEXT_ENVIRONMENTALLYFRIENDLY]: 'Environmentally friendly. No paper!',
  [IDS.SPLASHPAGE_AUTOPAY_TITLE]: 'Autopay is a convenient and reliable way to make payments',
};

const enMurabahaMessages = {
  ...enMessages,
  // Payments Home
  [IDS.HOME_CARD_LOAN]: 'Account',
  // Payments Splash
  [IDS.SPLASHPAGE_AUTOPAY_TEXT_ABILITYTOREMIT]: 'Ability to remit additional Murabaha payment funds with every automatic payment.',
  [IDS.SPLASHPAGE_AUTOPAY_TEXT_MORTGAGEPAYMENTS]: 'Murabaha Financing Transaction payments will be made on time.',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
